import { ValidLocale } from '@localisation'
import { IBusiness } from '@query'

export const businessDefaultInvoicingLanguage = (
  business?: Partial<IBusiness> | null
): ValidLocale => {
  const allowed = business?.country_config?.invoicing_languages
  const preferred = business?.country_config?.default_language
  if (preferred && (!allowed?.length || allowed.includes(preferred))) {
    return preferred as ValidLocale
  }
  if (allowed?.[0]) {
    return allowed[0] as ValidLocale
  }
  return ValidLocale.FI
}
